import React from "react";
import { useTranslation } from "react-i18next";
import { EVENT_RANGE_CHOICES, emptyEventHint, widerEventRange } from "../../utils/eventRange";

// Above an alarm / anomaly table: its own time range, and when the table is empty a line that says so, names the newest event found in
// the last 30 days and offers the next wider range in one click.
export default function EventRangeBar({ widgetId, choice, range, empty, kind, lastAt, onChange }) {
  const { t } = useTranslation();
  const wider = empty ? widerEventRange(range) : null;
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", padding: "6px 12px", borderBottom: "1px solid var(--border)", fontSize: 12, color: "var(--text-label)" }}>
      <label style={{ display: "flex", alignItems: "center", gap: 6 }}>
        {t("home.events.label")}
        <select
          aria-label={t("home.events.aria")}
          value={choice}
          onChange={(e) => onChange && onChange(widgetId, e.target.value)}
          style={{ background: "var(--bg-surface)", color: "var(--text-primary)", border: "1px solid var(--border)", borderRadius: 2, padding: "2px 6px" }}
        >
          {EVENT_RANGE_CHOICES.map((c) => <option key={c.value} value={c.value}>{c.label}</option>)}
        </select>
      </label>
      {empty && (
        <span style={{ flex: 1 }}>
          {emptyEventHint(kind, range, lastAt)}
          {wider && lastAt && (
            <button type="button" onClick={() => onChange && onChange(widgetId, wider)}
              style={{ marginLeft: 8, background: "none", border: "none", color: "var(--accent, #4fc3f7)", cursor: "pointer", textDecoration: "underline", padding: 0 }}>
              {t("home.events.widen", { range: t(`home.events.range.${wider}`) })}
            </button>
          )}
        </span>
      )}
    </div>
  );
}
